import _ from 'lodash';
import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import 'views/AssetCatalog/MarFiles/MarsTable/MarFileAssetView/MarFileAssetView.css';
import Tabs from 'react-bootstrap/Tabs';
import BlazePager from 'components/ui/pagination/BlazePager';
import { Request, Response, StatelessSignatures, StatelessSignaturesTxsCount } from 'store/marFiles/marFilesTypes';
import { BlazeMeterApiResponse } from 'types/rest/blazeMeterApiResponse';
import { showToastNotification } from 'store/ui/toasts/toastsActions';
import axios from 'axios/axios-base';
import { ToastType } from 'store/ui/toasts/toastsTypes';
import SimpleLoader from 'components/loaders/SimpleLoader';
import MarFileAssetViewResponseTab from 'views/AssetCatalog/MarFiles/MarsTable/MarFileAssetView/MarFileAssetViewResponseTab/MarFileAssetViewResponseTab';
import MarFileAssetViewRequestTab from 'views/AssetCatalog/MarFiles/MarsTable/MarFileAssetView/MarFileAssetViewRequestTab/MarFileAssetViewRequestTab';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Badge } from 'react-bootstrap';
import FullPageLoader from 'components/loaders/FullPageLoader';

interface MarFileAssetViewProps {
  marAssetId: number;
}

interface ILocalStateProps {
  currentTxnIndex: number;
  currentTxnId: number;
  isLoading: boolean;
  isRightSidePaneLoading: boolean;
  isReqResTabPaneLoading: boolean;
  statelessSignatures: StatelessSignatures[];
  statelessSignaturesTxsCount: StatelessSignaturesTxsCount | null;
  request: Request | null;
  responses: Response[];
  id: number;
}

export class MarFileAssetView extends Component<MarFileAssetViewProps & WithTranslation, ILocalStateProps> {
  state: ILocalStateProps = {
    currentTxnIndex: 1,
    currentTxnId: 0,
    isLoading: true,
    isRightSidePaneLoading: false,
    isReqResTabPaneLoading: false,
    statelessSignatures: [],
    statelessSignaturesTxsCount: null,
    request: null,
    responses: [],
    id: 0,
  };

  componentDidMount() {
    let sigId: number, id: number;
    axios
      .get(`/workspaces/{workspaceId}/assets/mar/${this.props.marAssetId}/stateless-signatures`)
      .then(response => {
        const result = (response.data as BlazeMeterApiResponse).result;
        sigId = result[0].id;
        this.setState({ statelessSignatures: result, isLoading: false });
        if (sigId !== null) {
          this.setState({ isRightSidePaneLoading: true });
          axios
            .get(`/workspaces/{workspaceId}/assets/mar/${this.props.marAssetId}/stateless-signatures/${sigId}`)
            .then(response => {
              const result = (response.data as BlazeMeterApiResponse).result;
              this.setState({ statelessSignaturesTxsCount: result });
              id = result.transactions[0].id;
              axios
                .get(
                  `/workspaces/{workspaceId}/assets/mar/${this.props.marAssetId}/stateless-signatures/${sigId}/transaction?txnId=${id}`,
                )
                .then(response => {
                  const result = (response.data as BlazeMeterApiResponse).result;
                  this.setState({
                    id: id,
                    request: result.request,
                    responses: result.responses,
                    isLoading: false,
                    isRightSidePaneLoading: false,
                  });
                })
                .catch(() => {
                  this.setState({ isLoading: false, isRightSidePaneLoading: false });
                  showToastNotification(ToastType.Danger, this.props.t('errorMsgs.failedToLoadMeta'));
                });
            })
            .catch(() => {
              this.setState({ isLoading: false, isRightSidePaneLoading: false });
              showToastNotification(ToastType.Danger, this.props.t('errorMsgs.failedToLoadMeta'));
            });
        }
      })
      .catch(() => {
        this.setState({ isLoading: false });
        showToastNotification(ToastType.Danger, this.props.t('errorMsgs.failedToLoadMeta'));
      });
  }

  componentDidUpdate(
    prevProps: Readonly<MarFileAssetViewProps & WithTranslation>,
    prevState: Readonly<ILocalStateProps>,
  ): void {
    if (prevState.isReqResTabPaneLoading) {
      this.setState({ isReqResTabPaneLoading: false });
    }
  }

  pageSelectedHandler = (statelessTransactionId: number, txnNo: number) => {
    const { statelessSignaturesTxsCount, currentTxnId } = this.state;
    this.setState({ isReqResTabPaneLoading: true });
    let tnxData = null;
    let id = null;

    try {
      if (statelessSignaturesTxsCount !== null) {
        tnxData = statelessSignaturesTxsCount.transactions;
      }
      if (tnxData !== null) {
        id = tnxData[txnNo - 1].id;
        if (id !== null) {
          axios
            .get(
              `/workspaces/{workspaceId}/assets/mar/${this.props.marAssetId}/stateless-signatures/${currentTxnId}/transaction?txnId=${id}`,
            )
            .then(response => {
              const result = (response.data as BlazeMeterApiResponse).result;
              this.setState({
                request: result.request,
                responses: result.responses,
              });
            })
            .catch(() => {
              this.setState({ isReqResTabPaneLoading: false });
              showToastNotification(ToastType.Danger, this.props.t('errorMsgs.failedToLoadMeta'));
            });
        }
      }
    } catch (err) {
      this.setState({ isReqResTabPaneLoading: false });
      showToastNotification(ToastType.Danger, this.props.t('errorMsgs.failedToLoadMeta'));
      console.log(err.message);
    }
    this.setState({
      currentTxnId: statelessTransactionId,
      currentTxnIndex: txnNo,
    });
  };

  navigateSignature = (txnId: number, event: any) => {
    if (this.state.statelessSignatures.length > 0) {
      if (event.keyCode === 38) {
        const matchedIdx = this.state.statelessSignatures.findIndex(element => element.id === txnId);
        if (matchedIdx !== 0) {
          this.currentTransactionChanged(this.state.statelessSignatures[matchedIdx - 1].id);
        } else {
          this.currentTransactionChanged(this.state.statelessSignatures[this.state.statelessSignatures.length - 1].id);
        }
      } else if (event.keyCode === 40) {
        const matchedIdx = this.state.statelessSignatures.findIndex(element => element.id === txnId);
        if (matchedIdx !== this.state.statelessSignatures.length - 1) {
          this.currentTransactionChanged(this.state.statelessSignatures[matchedIdx + 1].id);
        } else {
          this.currentTransactionChanged(this.state.statelessSignatures[0].id);
        }
      }
    }
  };

  currentTransactionChanged = (txnId: number) => {
    this.setState({ isRightSidePaneLoading: true });
    if (txnId != null)
      axios
        .get(`/workspaces/{workspaceId}/assets/mar/${this.props.marAssetId}/stateless-signatures/${txnId}`)
        .then(response => {
          const result = (response.data as BlazeMeterApiResponse).result;
          this.setState({ statelessSignaturesTxsCount: result });
          const id: any = result.transactions[0].id;
          axios
            .get(
              `/workspaces/{workspaceId}/assets/mar/${this.props.marAssetId}/stateless-signatures/${txnId}/transaction?txnId=${id}`,
            )
            .then(response => {
              this.setState({
                request: response.data.result.request,
                responses: response.data.result.responses,
              });
              this.setState({ isRightSidePaneLoading: false });
            })
            .catch(() => {
              this.setState({ isRightSidePaneLoading: false });
              showToastNotification(ToastType.Danger, this.props.t('errorMsgs.failedToLoadMeta'));
            });
        })
        .catch(() => {
          this.setState({ isRightSidePaneLoading: false });
          showToastNotification(ToastType.Danger, this.props.t('errorMsgs.failedToLoadMeta'));
        });
    this.setState({
      currentTxnId: txnId,
      currentTxnIndex: 1,
    });
  };

  generateTransactionName = (statelessSignatures: StatelessSignatures) => {
    let transactionName: string = statelessSignatures.operationName;
    if (_.isEmpty(transactionName)) {
      transactionName = +statelessSignatures.id + '';
    }
    return transactionName;
  };

  /**
   * Generates nav item for single transaction.
   * @param statelessSignatures
   */
  generateNavItem = (statelessSignatures: StatelessSignatures) => {
    const txnName = this.generateTransactionName(statelessSignatures).trim();
    return (
      <Nav.Item title={txnName} key={statelessSignatures.id} className="w-100">
        <Nav.Link
          className="text-truncate"
          eventKey={statelessSignatures.id}
          onSelect={() => this.currentTransactionChanged(+statelessSignatures.id)}
          onKeyDown={(event: any) => this.navigateSignature(+statelessSignatures.id, event)}
        >
          <span>{txnName}</span>
        </Nav.Link>
      </Nav.Item>
    );
  };

  /**
   * Generates nav pane with content for single transaction.
   */
  generateNavPane = () => {
    const { id, statelessSignaturesTxsCount, request, responses, isReqResTabPaneLoading } = this.state;
    let count = 0,
      opName = '';
    if (statelessSignaturesTxsCount != null) {
      count = statelessSignaturesTxsCount.transactionCount;
      opName = statelessSignaturesTxsCount.operationName;
    }
    const { currentTxnIndex, currentTxnId } = this.state;
    // Active page is either 1 or in case this is the visible item then take it from the state
    let activePage = 1;
    if (currentTxnId === id) {
      activePage = currentTxnIndex;
    }
    //Meta is display only for the first element (it is the default one)
    const meta = activePage === 1 ? <Badge variant="primary">Meta</Badge> : '';
    return (
      <Tab.Pane key={+activePage} eventKey={id} active={true}>
        <div className="bg-light border-left">
          <span className="float-right p-4">{meta}</span>

          <div className="p-4 d-flex">
            <h2 className="h2 mr-4 mt-2 text-break">{opName}</h2>
          </div>
          {count > 1 && (
            <div className="pl-4" style={{ position: 'relative', bottom: 20 }}>
              <p className="mb-0">
                Only the meta transaction and up to <b>5</b> specific transactions can be displayed for each signature.
              </p>
            </div>
          )}
          {count > 1 && (
            <div className="pl-4">
              <BlazePager
                total={count}
                activePage={activePage}
                pageSelectedHandler={(pageNumber: number) => {
                  this.pageSelectedHandler(id, pageNumber);
                }}
              />
            </div>
          )}
          <div style={{ position: 'relative' }}>
            {isReqResTabPaneLoading && (
              <div className="blur-background">
                <FullPageLoader />
              </div>
            )}

            <div className={isReqResTabPaneLoading ? 'blur' : ''}>
              <Tabs id="qa-mar-file-tabs" className="pl-4 mb-0">
                <Tab id="qa-tab-request-data" title={`Request Data`} eventKey="request">
                  {request && <MarFileAssetViewRequestTab requestData={request} />}
                </Tab>
                <Tab id="qa-tab-response-data" title={`Response Data`} eventKey="response">
                  {<MarFileAssetViewResponseTab responseData={responses} />}
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </Tab.Pane>
    );
  };

  render() {
    const { statelessSignatures, isRightSidePaneLoading } = this.state;
    let transactionCount = '';
    let marContent = <SimpleLoader />;

    if (statelessSignatures !== null && !this.state.isLoading) {
      // Override txn count from metadata
      transactionCount = statelessSignatures ? `(${statelessSignatures.length})` : '';

      const navTabs: any[] = [];
      const navTabsPanes: any = [];

      if (statelessSignatures.length !== 0) {
        // Create nav item and tab content for each item
        statelessSignatures.forEach((statelessSignatures: StatelessSignatures) => {
          navTabs.push(this.generateNavItem(statelessSignatures));
        });

        navTabsPanes.push(this.generateNavPane());
        const activeKey =
          statelessSignatures.length !== 0 && statelessSignatures[0].id !== null ? statelessSignatures[0].id : '';
        marContent = (
          <div className="mar-file-asset-view">
            <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
              <Row noGutters={true}>
                <Col xs={3} xl={2} style={{ maxHeight: '100vh', overflow: 'auto' }}>
                  <Nav
                    activeKey={activeKey}
                    variant="pills"
                    className="nav nav-pills nav-pills-vertical nav-pills-left flex-column"
                  >
                    {navTabs}
                  </Nav>
                </Col>
                <Col xs={9} xl={10}>
                  <Tab.Content>
                    <div style={{ position: 'relative' }}>
                      {isRightSidePaneLoading && (
                        <div className="blur-background">
                          <FullPageLoader />
                        </div>
                      )}

                      <div className={isRightSidePaneLoading ? 'blur' : ''}>{navTabsPanes}</div>
                    </div>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        );
      } else {
        marContent = <p>{this.props.t('detailedMeta.noStatelessSignatures')}</p>;
      }
    }

    return (
      <React.Fragment>
        <h2 className="mt-5">
          {this.props.t('detailedMeta.statelessSignatures')} {transactionCount}
        </h2>
        {marContent}
      </React.Fragment>
    );
  }
}

export default withTranslation('marFiles')(MarFileAssetView);
